/* global debounce, trapFocus */

if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();
      if (this.dataset.empty === 'false') this.init();
    }

    init() {
      this.fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };

      this.cartDrawer = document.getElementById('cart-drawer');
      this.itemStatus = document.getElementById('cart-line-item-status');
      this.currentTotalItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value, 10),
        0
      );

      this.currentQuantities = [];
      this.querySelectorAll('.cart-item').forEach((item) => {
        this.currentQuantities[item.dataset.variantId] = Number(item.querySelector('.qty-input__input').value);
      });

      /* custom by Mr Shoe */
      if (this.cartDrawer) {	
        this.estimateHandling();		
      }           
      /* custom by Mr Shoe */

      
      this.addEventListener('click', this.handleClick.bind(this));
      this.addEventListener('change', debounce(this.handleChange.bind(this)));
    }

    /**
     * Handles 'click' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleClick(evt) {
      if (!evt.target.matches('.js-remove-item')) return;
      evt.preventDefault();
      this.updateQuantity(evt.target.dataset.index, 0);
    }

    /**
     * Handles 'change' events on the cart items element.
     * @param {object} evt - Event object.
     */
    handleChange(evt) {
      this.updateQuantity(evt.target.dataset.index, evt.target.value, document.activeElement.name);
    }

    /**
     * Updates the quantity of a line item.
     * @param {number} line - Line item index.
     * @param {number} quantity - Quantity to set.
     * @param {string} name - Active element name.
     */
    async updateQuantity(line, quantity, name) {
      const cartDrawerContent = this.cartDrawer ? this.cartDrawer.querySelector('.drawer__content') : null;
      const cartDrawerContentScroll = cartDrawerContent ? cartDrawerContent.scrollTop : 0;
      const cartDrawerScroll = this.cartDrawer ? this.cartDrawer.scrollTop : 0;

      this.enableLoading(line);

      // clear all errors except this line's (which will be refreshed after this update)
      const lineErrorsId = `line-item-error-${line}`;
      const lineErrors = document.getElementById(lineErrorsId);
      document.querySelectorAll(`.cart-errors, .cart-item__error:not([id="${lineErrorsId}"])`).forEach((el) => {
        el.innerHTML = '';
        el.hidden = true;
      });

      const sections = this.getSectionsToRender().map((section) => section.section);
      this.fetchRequestOpts.body = JSON.stringify({
        line,
        quantity,
        sections: [...new Set(sections)],
        sections_url: window.location.pathname
      });

      try {
        const lineItem = document.getElementById(`cart-item-${line}`);
        const variantId = Number(lineItem.dataset.variantId);
        const oldTotalQuantity = this.currentTotalItemCount;
        const response = await fetch(theme.routes.cartChange, this.fetchRequestOpts);
        const data = await response.json();

        if (!response.ok) throw new Error(data.errors || response.status);

        const newTotalQuantity = data.item_count;

        if (this.cartDrawer) {
          cartDrawerContent.classList.toggle('drawer__content--flex', newTotalQuantity === 0);

          if (newTotalQuantity === 0) {
            const recommendations = this.cartDrawer.querySelector('product-recommendations');
            if (recommendations) recommendations.remove();
          }
        } else if (newTotalQuantity === 0) {
          // We're on the Cart page
          const cartTitle = this.closest('.cc-main-cart').querySelector('.js-cart-title');
          if (cartTitle) cartTitle.style.textAlign = 'center';

          const cartSummaryCss = document.getElementById('cart-summary-css');
          if (cartSummaryCss) cartSummaryCss.remove();

          const cartContent = document.getElementById('cart-summary-and-blocks');
          if (cartContent) cartContent.hidden = true;
        }

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const { selector } = section;
          const el = sectionEl.querySelector(selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data.sections[section.section], selector);
        });

        if (this.cartDrawer && newTotalQuantity === 0) {
          cartDrawerContent.classList.add('grow', 'flex', 'items-center');

          if (this.cartDrawer.querySelector('promoted-products')) {
            this.cartDrawer
              .querySelector('.drawer__content')
              .classList.toggle('drawer__empty-with-promotions', newTotalQuantity === 0);
          }
        }

        this.updateRecommendations(data.item_count > 0 ? data.items[0].product_id : null);
        this.updateLiveRegions();
        this.setFocus(line, newTotalQuantity, name);
        this.dataset.empty = newTotalQuantity === 0;
        this.currentTotalItemCount = newTotalQuantity;

        /* custom by Mr Shoe */
        if (data.item_count > 0) {		
          this.estimateHandling();		       
        }
        /* custom by Mr Shoe */        
        

        // Fire the on:line-item:change event if the line item quantity has changed
        if (oldTotalQuantity !== newTotalQuantity) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: data,
              variantId,
              oldQuantity: this.currentQuantities[variantId],
              newQuantity: Number(quantity)
            }
          }));
        }

        this.currentQuantities[variantId] = Number(quantity);

        lineErrors.innerHTML = '';
        lineErrors.hidden = true;
      } catch (error) {
        if (/^[0-9]+$/.test(error.message)) {
          lineErrors.textContent = theme.strings.cartError;
        } else {
          lineErrors.textContent = error.message;
        }
        lineErrors.hidden = false;
        console.log(error); // eslint-disable-line

        this.querySelectorAll('.cart-item__loader').forEach((loader) => {
          loader.hidden = true;
        });

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));

        const input = document.getElementById(`quantity-${line}`);
        input.value = input.dataset.initialValue;
        input.closest('quantity-input').currentQty = input.dataset.initialValue;
      } finally {
        this.classList.remove('pointer-events-none');

        // Attempt to maintain the same scroll position in the cart drawer
        if (cartDrawerContent) {
          requestAnimationFrame(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; });
          setTimeout(() => { cartDrawerContent.scrollTop = cartDrawerContentScroll; }, 0);
          requestAnimationFrame(() => { this.cartDrawer.scrollTop = cartDrawerScroll; });
          setTimeout(() => { this.cartDrawer.scrollTop = cartDrawerScroll; }, 0);
        }
      }
    }


       /* custom by Mr Shoe */ 


async getBankHolidays() {
  try {
    // Fetch bank holidays from gov.uk
    const response = await fetch('https://www.gov.uk/bank-holidays.json');
    const data = await response.json();
    const govUkBankHolidays = data['england-and-wales'].events.map(event => event.date);

    // Custom by Mr Shoe: England & Wales bank holidays only - the extra non-working-days
    // file on the CDN is no longer used, so this matches the checkout extension exactly.
    const additionalDates = [];

    // Combine both sets of dates
    this.bankHolidays = [...govUkBankHolidays, ...additionalDates];
  } catch (error) {
    console.error('Error fetching bank holidays or additional dates:', error);
    this.bankHolidays = [];
  }
}

getUKDate() {
  // Get the current time in the 'Europe/London' time zone
  const now = new Date();

  // Format the date and time components
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  const [
    { value: day }, ,
    { value: month }, ,
    { value: year }, ,
    { value: hour }, ,
    { value: minute }, ,
    { value: second },
  ] = formatter.formatToParts(now);

  // Construct a date string in ISO format
  const ukDateString = `${year}-${month}-${day}T${hour}:${minute}:${second}`;

  // Create a Date object in the 'Europe/London' time zone
  const ukDate = new Date(ukDateString);

  return ukDate;
}


    
parseCutoffTime(cutoffTime) {
  const match = String(cutoffTime || '14:00').match(/^(\d{1,2})(?::(\d{2}))?(?::\d{2})?$/);
  if (!match) return [14, 0];

  const hour = Math.min(Math.max(parseInt(match[1], 10), 0), 23);
  const minute = Math.min(Math.max(parseInt(match[2] || '0', 10), 0), 59);
  return [hour, minute];
}

 async estimateHandling() {
  // Ensure bank holidays are loaded
  if (!this.bankHolidays) await this.getBankHolidays();

  const currentDate = this.getUKDate();

  const currentWeekday = currentDate.getDay(); // 0 (Sun) to 6 (Sat)
  // build an ISO‑style YYYY‑MM‑DD for today
  const isoToday =
    `${currentDate.getFullYear()}-` +
    `${String(currentDate.getMonth()+1).padStart(2,'0')}-` +
    `${String(currentDate.getDate()).padStart(2,'0')}`;
  // true if Mon–Fri AND not in our fetched holiday list
  const isBusinessDay =
    currentWeekday >= 1 &&
    currentWeekday <= 5 &&
    !this.bankHolidays.includes(isoToday);
   


   
  const combinedHandleEl = document.querySelector('.combined-Handle');
  const fixedHandling = parseInt(combinedHandleEl.getAttribute('data-handling-fixed') || '0', 10);
  const timeBasedHandling = parseInt(combinedHandleEl.getAttribute('data-handling-time-based') || '-1', 10);
  let handlingRules = [];

  try {
    handlingRules = JSON.parse(combinedHandleEl.getAttribute('data-handling-rules') || '[]');
  } catch (error) {
    console.warn('Unable to parse cart handling rules.', error);
  }

  // Get the hour in the UK time zone as a number
  const ukHour = currentDate.getHours();

  const afterCutoff = ukHour >= 14 && isBusinessDay;
   const isHoliday   = !isBusinessDay;
  let combinedHandling;

  if (handlingRules.length) {
    combinedHandling = handlingRules.reduce((maxHandling, rule) => {
      const handling = Number(rule.handling) || 0;

      if (rule.time_based === false) {
        return Math.max(maxHandling, handling);
      }

      const [cutoffHour, cutoffMinute] = this.parseCutoffTime(rule.cutoff_time);
      const cutoffTimeToday = new Date(currentDate);
      cutoffTimeToday.setHours(cutoffHour, cutoffMinute, 0, 0);
      const afterRuleCutoff = currentDate >= cutoffTimeToday && isBusinessDay;
      // Custom by Mr Shoe: on a weekend/holiday DeliveryDate already starts on the next
      // working day, so only a past-cutoff working day adds a day (as in the checkout).
      const cutoffAdjustment = afterRuleCutoff ? 1 : 0;

      return Math.max(maxHandling, handling + cutoffAdjustment);
    }, 0);
  } else {
    const cutoffAdjustment = afterCutoff ? 1 : 0; // Custom by Mr Shoe: see above
    const adjustedTimeBasedHandling = timeBasedHandling >= 0
      ? timeBasedHandling + cutoffAdjustment
      : -1;
    combinedHandling = Math.max(fixedHandling, adjustedTimeBasedHandling);
  }
  let handlingFrom, handlingTo, handlingToDateObject;

  /* Custom by Mr Shoe: pre-order lines with a release date still ahead despatch on that day.
     If the latest such release is later than the basket's normal despatch day, the whole
     order is quoted from the release day with the Standard window, 2-3 delivery days (the
     slowest line decides; the checkout shows Express as 1-2 on its own option). */
  const todayYmd = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`;
  const futureReleases = handlingRules
    .map((rule) => String(rule.release || ''))
    .filter((ymd) => /^\d{4}-\d{2}-\d{2}$/.test(ymd) && ymd > todayYmd)
    .sort();
  if (futureReleases.length) {
    const [ry, rm, rd] = futureReleases[futureReleases.length - 1].split('-').map(Number);
    const releaseDate = new Date(ry, rm - 1, rd);
    const normalDespatch = this.DeliveryDate(currentDate, combinedHandling, 0, true);
    if (releaseDate >= normalDespatch) {
      handlingFrom         = this.DeliveryDate(releaseDate, 0, 2);
      handlingTo           = this.DeliveryDate(releaseDate, 0, 3);
      handlingToDateObject = this.DeliveryDate(releaseDate, 0, 3, true);
      handlingToDateObject.setHours(18, 0, 0, 0);
      combinedHandleEl.innerHTML += `
    <span class='handlingFrom' style='font-weight:bold'>${handlingFrom}</span>
    -
    <span class='handlingTo' style='font-weight:bold'>${handlingTo}</span>
  `;
      return;
    }
  }

  /* Custom by Mr Shoe: despatch counts Mon-Fri, the delivery leg counts Mon-SAT. Standard
     delivery is always 2-3 delivery days after despatch; an all-in-stock basket just despatches
     today - the same rules as the product page and the checkout extension. */
  if (combinedHandling === 0) {
    // Everything in stock: despatch today (or the next working day), deliver 2-3 days out.
    handlingFrom         = this.DeliveryDate(currentDate, 0, 2);
    handlingTo           = this.DeliveryDate(currentDate, 0, 3);
    handlingToDateObject = this.DeliveryDate(currentDate, 0, 3, true);
  } else {
    // Handling window: despatch after the handling days, then 2-3 delivery days.
    handlingFrom         = this.DeliveryDate(currentDate, combinedHandling, 2);
    handlingTo           = this.DeliveryDate(currentDate, combinedHandling, 3);
    handlingToDateObject = this.DeliveryDate(currentDate, combinedHandling, 3, true);
  }


  handlingToDateObject.setHours(18, 0, 0, 0);
  const formattedHandlingTo = handlingToDateObject.toISOString();

  combinedHandleEl.innerHTML += `
    <span class='handlingFrom' style='font-weight:bold'>${handlingFrom}</span>
    -
    <span class='handlingTo' style='font-weight:bold'>${handlingTo}</span>
  `;
}

   
BusinessDays(d, n, returnDateObject = false) {
  // Clone the input date object
  const date = new Date(d.getTime());

  // Ensure bank holidays data is available
  const bankHolidays = this.bankHolidays || [];

  // Helper: format the local date as YYYY-MM-DD
  const formatDate = (dt) => {
    const y  = dt.getFullYear();
    const m  = String(dt.getMonth()+1).padStart(2,'0');
    const dd = String(dt.getDate()).padStart(2,'0');
    return `${y}-${m}-${dd}`;
  };

   // ── NEW: if "date" is weekend or bank‑holiday, bump until it's a business day ──
  while (true) {
    const dow = date.getDay();
    const isWeekend = dow === 0 || dow === 6;
    const isHoliday = bankHolidays.includes(formatDate(date));
    if (!isWeekend && !isHoliday) break;
    date.setDate(date.getDate() + 1);
  } 

  // Increment the date by the specified number of working days
  let daysAdded = 0;
  while (daysAdded < n) {
    date.setDate(date.getDate() + 1);

    const dayOfWeek = date.getDay();
    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    const isBankHoliday = bankHolidays.includes(formatDate(date));

    if (isWeekend || isBankHoliday) continue;

    daysAdded++;
  }


  // Custom by Mr Shoe (2026-09-28): no extra days abroad any more (this helper is unused; DeliveryDate is the one in use).
  

  if (returnDateObject) {
    return date;
  } else {
    // Format and return the date string
    const options = { weekday: 'short', day: 'numeric', month: 'short' };
    return date.toLocaleDateString('en-GB', options);
  }
}

/* Custom by Mr Shoe */
/**
 * Despatch + delivery date. `despatchDays` are counted Monday-Friday (the
 * warehouse does not pick at weekends); `deliveryDays` are counted
 * Monday-SATURDAY, because the carriers deliver on a Saturday. Bank holidays
 * (the same list BusinessDays uses) are skipped for both. Outside the UK the
 * delivery days are Monday-Friday (2026-09-28).
 */
DeliveryDate(d, despatchDays, deliveryDays, returnDateObject = false) {
  const date = new Date(d.getTime());
  const bankHolidays = this.bankHolidays || [];
  const formatDate = (dt) => {
    const y  = dt.getFullYear();
    const m  = String(dt.getMonth()+1).padStart(2,'0');
    const dd = String(dt.getDate()).padStart(2,'0');
    return `${y}-${m}-${dd}`;
  };
  const isHoliday = (dt) => bankHolidays.includes(formatDate(dt));
  const isBusinessDay = (dt) => dt.getDay() !== 0 && dt.getDay() !== 6 && !isHoliday(dt);
  const isDeliveryDay = (dt) => dt.getDay() !== 0 && !isHoliday(dt);

  // Despatch cannot happen on a weekend or bank holiday: start on the next business day.
  while (!isBusinessDay(date)) date.setDate(date.getDate() + 1);

  let added = 0;
  while (added < despatchDays) {
    date.setDate(date.getDate() + 1);
    if (isBusinessDay(date)) added++;
  }

  // Custom by Mr Shoe (2026-09-28): abroad (UPS) the delivery days are working days, Monday to
  // Friday, with no extra padding - "if before 2pm, handling time + 2/3 days", as at checkout.
  const abroad = Shopify.country !== "GB";
  added = 0;
  while (added < deliveryDays) {
    date.setDate(date.getDate() + 1);
    if (abroad ? isBusinessDay(date) : isDeliveryDay(date)) added++;
  }

  if (returnDateObject) return date;
  const options = { weekday: 'short', day: 'numeric', month: 'short' };
  return date.toLocaleDateString('en-GB', options);
}

    /* custom by Mr Shoe */

    

    /**
     * Refreshes the cart by rerendering its sections and updating its product recommendations.
     */
    async refresh() {
      const errors = document.getElementById('cart-errors');
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const response = await fetch(`?sections=${[...new Set(sections)]}`);

        // The status is 400, refresh the whole cart and stop
        if (response.status === 400 && this.cartDrawer) {
          this.cartDrawer.refresh(true);
          return;
        }

        const data = await response.json();

        if (!response.ok) throw new Error(response.status);

        this.getSectionsToRender().forEach((section) => {
          const sectionEl = document.getElementById(section.id);
          if (!sectionEl) return;

          const el = sectionEl.querySelector(section.selector) || sectionEl;
          el.innerHTML = CartItems.getElementHTML(data[section.section], section.selector);
        });

        if (this.cartDrawer && this.querySelector('.cart-item')) {
          this.estimateHandling();
        }

        const firstCartItem = this.querySelector('.cart-item:first-child');
        this.updateRecommendations(firstCartItem ? firstCartItem.dataset.productId : null);

        errors.innerHTML = '';
        errors.hidden = true;
      } catch (error) {
        errors.textContent = theme.strings.cartError;
        errors.hidden = false;
        console.log(error); // eslint-disable-line

        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: error.message
          }
        }));
      }
    }

    /**
     * Returns an array of objects containing required section details.
     * @returns {Array}
     */
    getSectionsToRender() {
      let sections = [
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        },
        {
          id: 'free-shipping-notice',
          section: 'free-shipping-notice',
          selector: '.free-shipping-notice'
        }
      ];

      if (this.cartDrawer) {
        const cartDrawerId = this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '');
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: cartDrawerId,
            selector: 'cart-items'
          },
          {
            id: 'cart-promoted-products',
            section: cartDrawerId,
            selector: '#cart-promoted-products'
          },
          {
            id: 'cart-drawer',
            section: cartDrawerId,
            selector: '.cart-drawer__summary'
          },
          {
            id: 'cart-drawer-delivery-estimate',
            section: cartDrawerId,
            selector: '#cart-drawer-delivery-estimate'
          },
          {
            id: 'cart-drawer-media-promotion',
            section: cartDrawerId,
            selector: '#cart-drawer-media-promotion'
          }
        ];
      } else {
        sections = [
          ...sections,
          {
            id: 'cart-items',
            section: this.dataset.section,
            selector: 'cart-items'
          },
          {
            id: 'cart-summary',
            section: document.getElementById('cart-summary').dataset.section,
            selector: '.cart__summary'
          }
        ];
      }

      return sections;
    }

    /**
     * Gets the innerHTML of an element.
     * @param {string} html - Section HTML.
     * @param {string} selector - CSS selector for the element to get the innerHTML of.
     * @returns {string}
     */
    static getElementHTML(html, selector) {
      const tmpl = document.createElement('template');
      tmpl.innerHTML = html;

      const el = tmpl.content.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    /**
     * Shows a loading icon over a line item.
     * @param {string} line - Line item index.
     */
    enableLoading(line) {
      this.classList.add('pointer-events-none');

      const loader = this.querySelector(`#cart-item-${line} .cart-item__loader`);
      if (loader) loader.hidden = false;

      document.activeElement.blur();
      if (this.itemStatus) this.itemStatus.setAttribute('aria-hidden', 'false');
    }

    /**
     * Updates the cart recommendations.
     * @param {string} productId - The product id for which to find recommendations.
     */
    updateRecommendations(productId) {
      this.recommendations = this.recommendations || document.getElementById('cart-recommendations');
      if (!this.recommendations) return;

      if (productId) {
        this.recommendations.dataset.productId = productId;
        this.recommendations.init();
      } else {
        this.recommendations.innerHTML = '';
      }
    }

    /**
     * Updates the live regions.
     */
    updateLiveRegions() {
      this.itemStatus.setAttribute('aria-hidden', 'true');

      const cartStatus = document.getElementById('cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', 'false');

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    /**
     * Traps focus in the relevant container or focuses the active element.
     * @param {number} line - Line item index.
     * @param {number} itemCount - Item count.
     * @param {string} name - Active element name.
     */
    setFocus(line, itemCount, name) {
      const lineItem = document.getElementById(`cart-item-${line}`);
      let activeEl;

      if (lineItem) {
        activeEl = lineItem.querySelector(`[name="${name}"]`);
      }

      if (this.cartDrawer) {
        if (lineItem && activeEl) {
          trapFocus(this.cartDrawer, activeEl);
        } else if (itemCount === 0) {
          trapFocus(
            this.cartDrawer.querySelector('.js-cart-empty'),
            this.cartDrawer.querySelector('a')
          );
        } else if (this.cartDrawer.querySelector('.cart-item')) {
          trapFocus(this.cartDrawer, document.querySelector('.js-item-name'));
        }
      } else if (lineItem && activeEl) {
        activeEl.focus();
      }
    }
  }

  customElements.define('cart-items', CartItems);
}
